<template>
  <v-container fluid>
    <smartx-oms-trade-desk-wc :parent-environment="clientEnv" :auth-token="authToken" />
  </v-container>
</template>

<script>

export default {
  data () {
    return {
      // can pass this as parentEnv prop but not needed -- empty prop should be treated the same
      clientEnv: '1abc4124fa0e',
      authToken: ''
    }
  },
  created () {
    this.authToken = localStorage.getItem('token')
  }
}
</script>
